// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:32:59+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            6cee10ce22bf873d19c678ce122a11e8
//    Signature:      eyJpdiI6IjROMUNFVDNcL3dneU50Q3RDbG5vM0VRPT0iLCJ2YWx1ZSI6ImgyWFNFdUxqY0hrQkJWK1lUNkY1NjlWWHBxUVl0cUNXVSttT1FUT2NKK1Jwall5dzFWVWNGckZXcTIrOTNESURBbXZTenV6QzVMTjljVnhZRWFHUjBQMHlBV2hoTUoxT3Z6T0d3YUNreWp0N0NwcFpMQjhJVlNQN2xsVVVUVU0wcWdiVjQ2NUF1bFZZcXQ4RnUraXlHbitHdHdGcjk1dVFRdzYwR3BQSHcrZlU5RW9QbmhuMGhyVzI0VkkwNXFqdW1cL2duTEt0ZjRGUk1NZ1hSaWQyb3Q3XC94YXV4Tko3K21BNXpFTnVHdTM0K00zWktpSWVUVmI1czV2NHhrbUV1cVwvT3gyNE50dGt6Qjd0S3d2RGFFMmJ6Szd3VmFCa0dsTmpFNDhDOWQ5N1wvQXdMXC9wbE5haUpZYnpqRWJDV1JTZWFjOGIzUHp5NXNCQW40Rmk2Q2dcL2crMGhtS2hDRHM5c2lySVwvRG5EMnpJTFZaTHRoUlhLN1dGU1hcL3RkaG5SUGZjdUNiNXlhQ285cXJ4bklwOHNnUUFNZz09IiwibWFjIjoiYzE4NGMxZDZmZjU2MmY4Yzk2OTI2NTVkZWY3NGRmZTQ4YTNiMGEyNzE0MzA4MmJjNmE0OWZkODhkMTc3MmQ0NyJ9
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
